import { ToolInventoryTransferService } from './../tool-inventory-transfer/tool-inventory-transfer.service';
import { ToolInventoryModalService } from './../tool-inventory-modal/tool-inventory-modal.service';
import { Component, Injectable, Input, OnInit, ViewChild } from '@angular/core';
import { ToolsService } from 'src/app/service/tools/tools.service';
import { MomentService } from 'src/app/service/shared/moment/moment.service';
import { ToolSearchParams } from 'src/app/shared/models/toolSearchParams';
import { Router, ActivatedRoute } from '@angular/router';
import { DialogService } from 'src/app/service/dialog/dialog.service';
import { TableData } from 'src/app/shared/models/tableData';
import { ToolTransferService } from '../tool-transfer/tool-transfer.service';
import { BehaviorSubject, Subscription } from 'rxjs';
import { ToastService } from 'src/app/service/shared/toast/toast.service';
import { LoaderService } from 'src/app/service/shared/loader/loader.service';
import { ToolSettingsTableComponent } from '../../settings/tool-settings/tool-settings-table/tool-settings-table.component';

@Component({
  selector: 'app-tool-list',
  templateUrl: './tool-list.component.html',
  styleUrls: ['./tool-list.component.scss'],
})
@Injectable({
  providedIn: 'root',
})
export class ToolListComponent implements OnInit {
  @ViewChild('toolSettingsTable') toolSettingsTable: ToolSettingsTableComponent;
  private refreshAllSource = new BehaviorSubject<any>({});
  refreshAll = this.refreshAllSource.asObservable();

  filterType;
  constructor(
    private toolsService: ToolsService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private dialogService: DialogService,
    private toolTransferService: ToolTransferService,
    private toolInventoryTransferService: ToolInventoryTransferService,
    private toolInventoryModalService: ToolInventoryModalService,
    private toastService: ToastService,
    private loaderService: LoaderService,
    private momentService: MomentService,
  ) { }

  @Input() data: any;
  @Input() tableData: TableData;
  @Input() tableFilters: Array<any>;
  @Input() moreFilters: Array<any>;
  @Input() searchParams: ToolSearchParams = { page: 1, limit: 50 };
  @Input() toolExportParams: ToolSearchParams = {};
  @Input() toolModelExportParams: ToolSearchParams = {};
  @Input() toolTransferExportParams: ToolSearchParams = {};
  @Input() toolInventoryExportParams: ToolSearchParams = {};
  @Input() source: string;
  @Input() modelId: number;
  @Input() hideTableBar: Boolean;
  @Input() hideTablePaging: Boolean;
  @Input() defaultSortOrder: string;

  modelDetail: any = {
    'asset-classes': {},
    categories: {},
    manufacturers: {},
  };
  dialogRecord: any = {};
  endpoint: string;
  selectedItems: Array<any> = [];
  filterData: Array<any> = [];
  subscription: Subscription;
  actionSource: string;
  refreshSubscription: Subscription;

  ngOnInit(): void {
    this.getCount();

    if (this.data) {
      this.tableData.data = this.data;
      return;
    }

    this.filterType =
      this.source === 'tools' ? 'toolFilter' : this.source === 'models' ? 'modelFilter' : 'transferFilter';
    this.loadSelectedItems();
  }

  updateFilters(filterData) {
    this.tableFilters.map(filter => {
      filter.default = filterData[filter.propertyName] ? filterData[filter.propertyName] : '';
    });
  }

  ngAfterViewInit() {
    if (this.data) return;
    setTimeout(() => {
      this.toolsService.setTotalCountLabel(this.tableData.type);
    });
  }

  ngOnDestroy() {
    if (this.refreshSubscription) this.refreshSubscription.unsubscribe();
  }

  getData() {
    this.loaderService.displayLoader();

    this.toolsService.read[this.tableData.type](this.searchParams).subscribe(
      res => {
        this.loaderService.hideLoader();
        this.tableData.data = res.data;
        this.tableData.pagination = res.pagination;
        this.tableData.meta = res.meta;
      },
      error => {
        this.loaderService.hideLoader();
        console.error(error);
      },
    );
  }

  getCount() {
    this.toolsService.count[this.tableData.type]({}).subscribe(
      res => {
        this.toolsService.setTotalCount(res.data.count);
      },
      error => {
        console.error(error);
      },
    );
  }

  handleAction(actionData): void {
    const { action, payload, source } = actionData;
    this.actionSource = source;
    this.actions[action](payload);
  }

  actions = {
    edit: record => this.performEdit(record),
    delete: record => this.performDelete(record),
    status: record => this.performStatusChange(record),
    sort: sortData => this.performSorting(sortData),
    transfer: record => this.performTransfer(record),
    inventory: record => this.performInventory(record),
    inventoryTransfer: record => this.performInventoryTransfer(record),
    batchExport: () => this.performToolBatchExport(),
    copy: record => this.performCopy(record),
    add: record => this.performAdd(record),
  };

  performSearch(searchString: string, shouldSkipFetch: boolean = false): void {
    this.searchParams.search = searchString;
    //Exclude search embed for export param objects
    const { embed, ...searchParams } = this.searchParams;
    this.toolExportParams = Object.assign(this.toolExportParams, searchParams);
    this.toolModelExportParams = Object.assign(this.toolModelExportParams, searchParams);
    this.toolTransferExportParams = Object.assign(this.toolTransferExportParams, searchParams);
    this.toolInventoryExportParams = Object.assign(this.toolInventoryExportParams, searchParams);

    if (shouldSkipFetch) return

    this.getData();
  }

  performFilterAndSearch({ search, searchFilters }) {
    this.performSearch(search, true)
    this.performFilter(searchFilters, true)

    if (!searchFilters?.order) {
      this.toolSettingsTable.resetSort()
    } else {
      this.toolSettingsTable.setSort(searchFilters.order)
    }

    this.getData()
  }

  performSorting(sortData: string) {
    this.searchParams.order = sortData;
    //Add scope for only fetching tools associated to a model on tool-model-page
    if (this.actionSource === 'models' && this.modelId) {
      this.searchParams['scope[modelTools]'] = this.modelId;
    }
    this.getData();
  }

  performPaging(pageLink: string): void {
    if (parseInt(pageLink)) {
      this.searchParams.page = parseInt(pageLink);
    }
    this.getData();
  }

  refreshDataForSelectAll(dataLimit: number = 100000) {
    this.searchParams = Object.assign(this.searchParams, this.filterData);
    this.searchParams.page = 1;
    this.searchParams.limit = dataLimit;
    this.searchParams = this.setFilterParams(this.searchParams);
    this.getTools(true);
  }

  getTools(fetchAll: boolean = false) {
    this.loaderService.displayLoader();

    this.toolsService.read[this.tableData.type](this.searchParams).subscribe(
      res => {
        this.loaderService.hideLoader();
        this.tableData.data = res.data ? res.data : res;
        this.tableData.pagination = res.pagination;
        this.tableData.meta = res.meta;
        if (fetchAll) this.refreshAllSource.next(res);
      },
      err => {
        this.loaderService.hideLoader();
        console.error(err);
      },
    );
  }

  setFilterParams(params) {
    const filterParams = Object.keys(params).reduce((filters, key) => {
      filters[key] = params[key];
      // remove empty scopes
      if (key.indexOf('scope') >= 0 && !filters[key]) delete filters[key];
      if (key.indexOf('assignmentFilter') >= 0 && !filters[key]) delete filters[key];
      return filters;
    }, {});
    return filterParams;
  }

  performFilter(filterData, shouldSkipFetch: boolean = false) {
    this.filterData = filterData;
    // set default limit
    this.searchParams.limit = 50;
    // method used to add new filtered data and clean up old keys missing data
    this.searchParams = Object.assign(this.searchParams, filterData);
    this.toolExportParams = Object.assign(this.toolExportParams, filterData);
    this.toolModelExportParams = Object.assign(this.toolModelExportParams, filterData);
    this.toolTransferExportParams = Object.assign(this.toolTransferExportParams, filterData);
    this.toolInventoryExportParams = Object.assign(this.toolInventoryExportParams, filterData);
    this.searchParams = this.setFilterParams(this.searchParams);
    this.toolExportParams = this.setFilterParams(this.toolExportParams);
    this.toolModelExportParams = this.setFilterParams(this.toolModelExportParams);
    this.toolTransferExportParams = this.setFilterParams(this.toolTransferExportParams);
    this.toolInventoryExportParams = this.setFilterParams(this.toolInventoryExportParams);

    if (shouldSkipFetch) return

    this.getTools();
  }

  performStatusChange(record): void {
    const { id, name, description, enabled } = record;
    const payload = { id, data: { name, description, enabled } };
    payload.data.enabled = !payload.data.enabled;
    this.toolsService.status[this.tableData.type](payload).subscribe(
      res => {
        this.getData();
        this.toastService.showToast('Successfully updated status', 'success');
      },
      err => {
        this.toastService.showToast('Error in updating status', 'error');
        this.getData();
        console.error('error:', err);
      },
    );
  }

  createTool(): void {
    if (this.source === 'models') {
      this.bindTool();
    }
    this.toolsService.create[this.tableData.type]().subscribe(
      res => {
        this.router.navigate(['./add/', res.data.id], {
          relativeTo: this.activatedRoute,
        });
      },
      err => {
        this.toastService.showToast('Failed to create a new tool record', 'error');
        console.error('error:', err);
      },
    );
  }

  createModel() {
    this.toolsService.create['models']().subscribe(
      res => {
        this.router.navigate(['./add/', res.data.id], {
          relativeTo: this.activatedRoute,
        });
      },
      err => {
        this.toastService.showToast('Failed to create a new model record', 'error');
        console.error('error:', err);
      },
    );
  }

  performAdd(payload: any): void {
    this.toolsService.create['tools']().subscribe(
      res => {
        this.updateTools(res.data.id, payload);
      },
      err => {
        console.error('error:', err);
      },
    );
  }

  updateTools(toolId, payload) {
    const createToolPayload = {
      id: toolId,
      data: {
        toolModelId: payload.id,
        inspectionRequired: payload.inspectionRequired,
        maintenanceRequired: payload.maintenanceRequired,
      },
    };
    this.toolsService.update['tools'](createToolPayload).subscribe(result => {
      this.router.navigate(['/tools/edit/', toolId], {
        relativeTo: this.activatedRoute,
      });
    }),
      err => {
        console.error('error:', err);
      };
  }

  bindTool() {
    this.toolsService.create['tools']().subscribe(res => {
      const createToolPayload = {
        id: res.data.id,
        data: {
          toolModelId: this.modelId,
        },
      };
      this.updateTool(createToolPayload);
    });
  }

  updateTool(payload) {
    this.toolsService.update['tools'](payload).subscribe(_ => {
      this.router.navigate(['/tools/edit/', payload.id], {
        relativeTo: this.activatedRoute,
      });
    }),
      err => {
        console.error('error:', err);
      };
  }

  performCreate(_: string): void {
    if (this.tableData.type === 'tools') this.createTool();
    else if (this.tableData.type === 'models') this.createModel();
  }

  performEdit(record: any): void {
    this.router.navigate(['./edit/', record.id], {
      relativeTo: this.activatedRoute,
    });
  }

  performDelete(record): void {
    this.dialogRecord.actionType = 'delete';
    this.dialogRecord.actionName = 'Delete';

    if (this.tableData.type === 'tools') {
      const toolId = record.toolId ? record.toolId : record.legacyToolId;
      const desc = record.description ? `: ${record.description}` : '';
      this.dialogRecord.name = `${toolId}${desc}`;
    } else if ((this.tableData.type = 'models')) {
      this.dialogRecord.name = record.name;
    }

    this.dialogRecord.data = record;

    this.dialogService.open('delete-dialog').then(response => {
      // if user decided to continue, proceed with change
      if (!response) return

      this.toolsService.delete[this.tableData.type](record.id).subscribe(
        res => {
          this.toastService.showToast('Deleted successfully', 'success');
          this.getData();
          this.getCount();
          if (this.tableData.type === 'tools' && this.toolTransferService.get(record.id)) {
            this.toolTransferService.remove(record.id);
          }
        },
        err => {
          if (err.status === 423) {
            this.toastService.showToast(err.error.errors[0].error, 'error');
          } else {
            this.toastService.showToast('Failed to delete record', 'error');
          }
          this.getData();
        },
      );

    });
  }

  handleSelectAll(items: any) {
    this.selectedItems = items;
    if (this.tableData.type === 'tools') {
      this.toolTransferService.batchAdd(items);
    }

    if (this.tableData.type === 'inventories') {
      this.toolInventoryTransferService.batchAdd(items);
      this.toolInventoryModalService.batchAdd(items);
    }
  }

  handleRemoveAll(_: any) {
    this.selectedItems = [];
    if (this.tableData.type === 'tools') {
      this.toolTransferService.clear();
    }

    if (this.tableData.type === 'inventories') {
      this.toolInventoryTransferService.clear();
      this.toolInventoryModalService.clear();
    }
  }

  handleSelectedAdd(id: number) {
    const item = this.tableData.data.find(row => row.id == id);

    if (this.tableData.type === 'tools') {
      this.toolTransferService.add(item);
    }

    if (this.tableData.type === 'inventories') {
      this.toolInventoryTransferService.add(item);
      this.toolInventoryModalService.add(item);
    }
  }

  handleSelectedRemove(id: number) {
    if (this.tableData.type === 'tools') {
      this.toolTransferService.remove(id);
    }

    if (this.tableData.type === 'inventories') {
      this.toolInventoryTransferService.remove(id);
      this.toolInventoryModalService.remove(id);
    }
  }

  performTransfer(record: any): void {
    //Refresh tools after successful tool transfer
    this.refreshSubscription = this.toolTransferService.refreshToolsSubscriber.subscribe(res => {
      if (res.next && !this.refreshSubscription?.closed) {
        this.getTools();
      }
    });

    if (record) {
      this.toolTransferService.transfer(record, this.refreshSubscription);
    } else {
      this.toolTransferService.batchTransfer(this.refreshSubscription);
    }
  }

  performInventoryTransfer(record: any): void {
    //Refresh tools after successful tool transfer
    this.refreshSubscription = this.toolInventoryTransferService.refreshToolsSubscriber.subscribe(res => {
      if (res.next && !this.refreshSubscription?.closed) {
        this.getTools();
      }
    });

    if (record) {
      this.toolInventoryTransferService.transfer(record, this.refreshSubscription);
    } else {
      this.toolInventoryTransferService.batchTransfer(this.refreshSubscription);
    }
  }

  performInventory(record: any): void {
    //Refresh tools after successful tool transfer
    this.refreshSubscription = this.toolInventoryModalService.refreshToolsSubscriber.subscribe(res => {
      if (res.next && !this.refreshSubscription?.closed) {
        this.getTools();
      }
    });

    if (record) {
      this.toolInventoryModalService.inventory(record, this.refreshSubscription);
    } else {
      this.toolInventoryModalService.batchInventory(this.refreshSubscription);
    }
  }

  performCopy(record): void {
    this.toolsService.duplicate[this.tableData.type](record.id).subscribe(
      res => {
        this.toastService.showToast('Successfully duplicated', 'success');
        setTimeout(() => {
          this.router.navigate(['./edit/', res.data.id], {
            relativeTo: this.activatedRoute,
          });
        }, 500);
      },
      err => {
        this.toastService.showToast('Error in duplicating tool', 'error');
        console.error('error:', err);
      },
    );
  }

  handleSelectedChange(records: any[]) {
    this.selectedItems = records;
  }

  performToolBatchExport(toolExportOptions = undefined): void {
    const { toolExportType } = toolExportOptions;
    // immutably remove limit and page
    const { limit, page, attributes, ...exportParams } = this.toolExportParams;
    exportParams.group = 'toolId';
    exportParams.exportType = toolExportType;

    this.toolsService.export['tools'](exportParams).subscribe(
      res => {
        this.loaderService.hideLoader();
        this.downloadFile(res.body, 'tools');
      },
      err => {
        this.loaderService.hideLoader();
        console.error(err);
      },
    );
  }

  performToolModelBatchExport(toolModelExportOptions = undefined): void {
    const { modelExportType } = toolModelExportOptions;
    // immutably remove limit and page
    const { limit, page, attributes, ...exportParams } = this.toolModelExportParams;
    exportParams.exportType = modelExportType;
    this.toolsService.export['models'](exportParams).subscribe(
      res => {
        this.loaderService.hideLoader();
        this.downloadFile(res.body, 'models');
      },
      err => {
        this.loaderService.hideLoader();
        console.error(err);
      },
    );
  }

  performTransfersBatchExport(transferExportOptions = undefined): void {
    const { transferExportType } = transferExportOptions;
    // immutably remove limit and page
    const { limit, page, attributes, ...exportParams } = this.toolTransferExportParams;
    exportParams.exportType = transferExportType;
    this.toolsService.export['transfers'](exportParams).subscribe(
      res => {
        this.loaderService.hideLoader();
        this.downloadFile(res.body, 'transfers');
      },
      err => {
        this.loaderService.hideLoader();
        console.error(err);
      },
    );
  }

  performInventoryBatchExport(inventoryExportOptions = undefined): void {
    const { inventoryExportType } = inventoryExportOptions;
    // immutably remove limit and page
    const { limit, page, attributes, ...exportParams } = this.toolInventoryExportParams;

    exportParams.exportType = inventoryExportType;
    this.toolsService.export['inventories'](exportParams).subscribe(
      res => {
        this.loaderService.hideLoader();
        this.downloadFile(res.body, 'inventories');
      },
      err => {
        this.loaderService.hideLoader();
        console.error(err);
      },
    );
  }

  downloadFile(blob: any, fileType: String) {
    const a = document.createElement('a');
    const currentDate = this.momentService.getCurrentDate('MMDDYYYY');
    const url = window.URL.createObjectURL(blob);
    a.href = url;
    a.download = `${currentDate}_${fileType}_export.csv`;
    a.click();
    window.URL.revokeObjectURL(url);
    a.remove();
  }

  async loadSelectedItems() {
    if (this.tableData.type === 'tools') {
      this.subscription = this.toolTransferService.selectedItems.subscribe(
        data => {
          this.selectedItems = data.map(row => row.id);
        },
        e => console.error('Transfer service error', e),
      );
    }

    if (this.tableData.type === 'inventories') {
      this.subscription = this.toolInventoryModalService.selectedInventoryItems.subscribe(
        (data: any) => {
          this.selectedItems = data.map(row => row?.toolInventoryJunctionId);
        },
        e => console.error('Inventory service error', e),
      );

      this.toolInventoryTransferService.selectedInventoryItems.subscribe(
        (data: any) => {
          this.selectedItems = data.map(row => row?.toolInventoryJunctionId)
        },
        e => console.error('Inventory transfer service error', e),
      )
    }
  }

  onClearFilters() {
    if (this.toolSettingsTable) {
      this.toolSettingsTable.resetSort();

    } else {
      console.warn('ToolSettingsComponent is undefined');
    }
  }
}
